import { render, staticRenderFns } from "./RepetitionWordsInfoDialog.vue?vue&type=template&id=66b310fc&"
import script from "./RepetitionWordsInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./RepetitionWordsInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports